/**
 * Minimum width of the main content column, in rem. Bound on `<main>` and the threshold the
 * push-vs-overlay decisions measure against. Kept out of the barrel: internal to the layout.
 */
export const MAIN_CONTENT_MIN_WIDTH_REM = 24;
